import api, { ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { GetTokenSheetInfoDto, SingleInputDto } from '@/api.types';

/**
 * Retrieves information associated with an attendance sheet token as input.
 *
 * @param dto - The token string representing the attendance sheet.
 * @returns The result of executing the use case to retrieve token information.
 */
export async function retrieveAttendanceSheetTokenInfo(dto: SingleInputDto): Promise<GetTokenSheetInfoDto> {

  try {
    return (await api.post(Endpoints.AUTH + '/folha/token/info', dto)).data;
  } catch (error) {
    return ValidateAxiosError(error, 'Falha.');
  }
}
